import { createRoute, lazyRouteComponent, Outlet, redirect } from '@tanstack/react-router';
import { rootRoute } from '../services/routing/rootRoute';
import { routeLabels } from '../services/routing/routeMetadata';

const deploymentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'deployment',
  component: Outlet,
  staticData: { ...routeLabels('Deployment'), breadcrumbTo: '/deployment/services' },
});

const deploymentIndexRoute = createRoute({
  getParentRoute: () => deploymentRoute,
  path: '/',
  beforeLoad: () => redirect({ to: '/deployment/services', throw: true }),
});

const deploymentServicesRoute = createRoute({
  getParentRoute: () => deploymentRoute,
  path: 'services',
  component: lazyRouteComponent(() => import('@puffin/service-deployments/dashboard-page'), 'DashboardPage'),
  staticData: { ...routeLabels('Service Dashboard'), navigationPath: '/deployment/services' },
});

const trialRoute = createRoute({
  getParentRoute: () => deploymentRoute,
  path: 'trial',
  component: lazyRouteComponent(() => import('@puffin/system-templates/trial-templates-page'), 'TrialTemplatesPage'),
  staticData: { ...routeLabels('Trial Demo Data'), navigationPath: '/deployment/trial' },
});

export const deploymentRouteTree = deploymentRoute.addChildren([deploymentIndexRoute, deploymentServicesRoute, trialRoute]);
